import React, { useMemo } from 'react';
import DataTable from 'shared/components/table/DataTable';
import { ticketColumns } from 'shared/components/table/ticketColumns';
import { getEmployeeTickets } from 'shared/api/support';
import { useAuth } from 'shared/hooks';

// "My Active Tickets" widget
export default function AssigneeTicketTable() {
  const { user: { id: userId } } = useAuth();

  const assigneeColumns = useMemo(() => {
    const temp = [...ticketColumns];
    const index = temp.findIndex((col) => col.name === 'Assigned To');
    temp.splice(index, 1);
    return temp;
  }, []);

  return (
    <>
      <div className="item-child-title">
        My Active Tickets
      </div>
      <DataTable
        columns={assigneeColumns}
        noExportButton
        noSearchForm
        rowId="id"
        baseSearch={`assignee_id=${userId}`}
        searchRequest={getEmployeeTickets}
      />
    </>
  );
}
